import { Address } from '@spartacus/core';
import { StatusRequest } from './request-status.model';

export enum ADDRESS_TYPE {
  SHIP_ADDRESS = 'SHIP_ADDRESS',
  DROP_SHIP_ADDRESS = 'DROP_SHIP_ADDRESS',
}

export interface AddressRequest extends StatusRequest {
  address?: Address;
}

declare module '@spartacus/core' {
  interface Address {
    dropShippingAddress?: boolean;
    defaultWarehouseCode?: string;
  }

  interface Country {
    diallingCode?: string;
    phoneMask?: string;
  }
}

export {};
